export const lightTheme = {
  main: "#FFF",
  mainContainer: "#F4F7FD",

  fontColor: "#000112",
  secondFontColor: "#828FA3",
  fontColorHover: "#635FC7",
  labelColor: "#828FA3",
  labelHover: "#A8A4FF",
  boardHover: "rgba(168, 164, 255, 0.5)",

  //createSubTask colors
  createSubtaskBtnBG: "#F0EFFA",
  createSubTaskText: "#635FC7",

  //createTask colors
  createTaskText: "#FFF",
  createTaskBtnBG: "#635FC7",

  //Modal Background color
  modalBG: "#FFF",
  modalBackDrop: "rgba(0, 0, 0, 0.5)",

  //Modal subtask background
  subTaskBG: "#E4EBFA",

  //Active task board colors
  boardHoverBg: "#E4EBFA",
  boardHoverTextColor: "#635FC7",
  activeBoardBg: "#635FC7",
  activeBoardTextColor: "#FFFFFF",


};
export const darkTheme = {
  main: "#2B2C37",
  mainContainer: "#22232E",
  fontColor: "#fff",
  secondFontColor: "#828FA3",
  fontColorHover: "#635FC7",
  labelColor: "#828FA3",
  labelHover: "#A8A4FF",
  boardHover: "#FFF",

  //createSubTask colors
  createSubtaskBtnBG: "#FFF",
  createSubTaskText: "#635FC7",

  //createTask colors
  createTaskText: "#FFF",
  createTaskBtnBG: "#635FC7",

  //Modal Background color
  modalBG: "#2B2C37",
  modalBackDrop: "rgba(0, 0, 0, 0.5)",
  // this color may need to be changed once we test out the dark mode

  //Modal subtask background
  subTaskBG: "#3E3F4E",

  //Active task board colours
  boardHoverBg: "#FFFFFF",
  boardHoverTextColor: "#635FC7",
  activeBoardBg: "#635FC7",
  activeBoardTextColor: "#FFFFFF",
};
